import { render, staticRenderFns } from "./EquipTable.vue?vue&type=template&id=2faa1b98&scoped=true"
import script from "./EquipTable.vue?vue&type=script&lang=js"
export * from "./EquipTable.vue?vue&type=script&lang=js"
import style0 from "./EquipTable.vue?vue&type=style&index=0&id=2faa1b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa1b98",
  null
  
)

export default component.exports